import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DetailAlamat } from '../../interfaces/api/alamat';
import { Router } from '@angular/router';
import { FullAddressJSON } from 'src/app/interfaces/address';

@Component({
  selector: 'app-alamat-card',
  templateUrl: './alamat-card.component.html',
  styleUrls: ['./alamat-card.component.scss'],
})
export class AlamatCardComponent implements OnInit {
  @Input() alamat: DetailAlamat;
  @Input() selectedCardId: number | null;
  @Output() selectCard = new EventEmitter<number>();
  @Output() selectAsPrimary = new EventEmitter<number>();
  @Output() deleteAddress = new EventEmitter<number>();
  isSelected = false;
  addressObject: FullAddressJSON;
  full_address: string;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.getFullAddress();
  }

  onCardClick(cardId: number) {
    this.selectCard.emit(cardId);
  }
  onSelectAsPrimary(cardId: number) {
    this.selectAsPrimary.emit(cardId);
  }
  onDeleteAddress(cardId: number) {
    this.deleteAddress.emit(cardId);
  }

  getFullAddress() {
    try {
      const full_address = JSON.parse(this.alamat?.full_address) as FullAddressJSON;
      this.full_address =
        full_address?.address +
        `, ${full_address.kecamatan.name}, ${full_address.kota.name}, ${full_address.provinsi.name}`;
      this.addressObject = full_address;
    } catch (error) {
      this.full_address = this.alamat?.full_address;
    }
  }

  isCardSelected() {
    return this.selectedCardId === this.alamat.id;
  }

  goToUpdateAddress(event: Event) {
    event.stopPropagation();
    this.router.navigate(['/edit-address', { addressID: this.alamat.id }]);
  }
}
